// extracted by mini-css-extract-plugin
export default {"root":"root___j5Qk3","btn":"btn___E2W40","emailIcon":"emailIcon___xQwZO"};